@if(content){
<div class="flex flex-middle m-b">
    <div class="ratio-1-1"
         style="width: 36px">
        <img class="rf"
             [image]="content?.image">
    </div>
    <div class="p-l-2"
         style="width: calc(100% - 36px);">
        <p class="p2">{{ copy }}</p>
    </div>
</div>
}
